<template>
  <div>
    <div class="manage-header">
      <common-form inline :formLabel="formLabel" :form="searchFrom">
        <el-button type="primary" @click="getList(searchFrom.keyword)">搜索</el-button>
      </common-form>
    </div>
    <cont-download-table
      :tableData="tableData"
      :tableLabel="tableLabel"
      :config="config"
      @changePage="changePage"
      @download="download"
      @contfiling="contfiling"
      @backToLoms="backToLoms"
    >
    </cont-download-table>
  </div>
</template>

<script>
import ContDownloadTable from '../../components/ContDownloadTable'
import { pageContractSendInfoApi } from '../../api/getData'
import { downloadContApi } from '../../api/getData'
import { contFilingApi } from '../../api/getData'
import { contToLomsApi } from '../../api/getData'
import CommonForm from '../../components/CommonForm'

export default {
  components: {
    ContDownloadTable,
    CommonForm
  },
  data: function() {
    return {
      currentUser: '',
      isShow: false,
      tableData: [
        {
          contractId: '',
          bgNo: '',
          contractName: '',
          partyaMobile: '',
          partybMobile: '',
          files: '',
          sfhc: ''
        }
      ],
      tableLabel: [
        {
          prop: 'contractId',
          label: '合同编号',
          width: 300
        },
        {
          prop: 'bgNo',
          label: '变更编号',
          width: 200
        },
        {
          prop: 'docTitle',
          label: '合同名称',
          width: 450
        },
        {
          prop: 'partyaMobile',
          label: '发起方账号',
          width: 120
        },
        {
          prop: 'createTime',
          label: '发起时间',
          width: 200
        },
        {
          prop: 'realnameA',
          label: '发起方名称',
          width: 200
        },
        {
          prop: 'realnameB',
          label: '接收方名称',
          width: 200
        },
        /*
        {
          prop: 'filingMsg',
          label: '归档状态',
          width: 120
        },
        */
        {
          prop: 'sfhcMsg',
          label: '是否回传',
          width: 50
        }
      ],
      operateForm: {
        contractId: '',
        customerId: '',
        signKeyword: ''
      },
      config: {
        page: 1,
        size: 5,
        total: 0,
        loading: false
      },
      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: '',
          placeholder: '合同编号或名称'
        }
      ]
    }
  },
  methods: {
    getList(val) {
      this.config.loading = true
      this.config.size = 5
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      val ? (this.config.page = 1) : ''

      //调用查询接口
      pageContractSendInfoApi(this.config.page, this.config.size, this.currentUser, '1', '1', val, val).then(res => {
        res = res.data
        this.tableData = res.data
        this.config.total = res.total
        this.config.size = res.pageSize
        this.config.loading = false
      })
    },
    changePage(val) {
      this.config.page = val
      this.getList('1', '1')
    },
    download(row) {
      this.$confirm('确认下载该合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.config.loading = true
          downloadContApi(row.contractId, row.docTitle, row.conUuid).then(res => {
            if (res.status == 200 && res.data.type == 'application/json') {
              const reader = new FileReader() //创建一个FileReader实例
              reader.readAsText(res.data, 'utf-8') //读取文件,结果用字符串形式表示
              reader.onload = function() {
                const result = JSON.parse(reader.result)
                window.open(result.data)
              }
            } else {
              this.$message({
                type: 'warning',
                message: '下载异常'
              })
            }
            this.config.loading = false
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          })
        })
    },

    download1(row) {
      this.$confirm('确认下载该合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.config.loading = true
          downloadContApi(row.contractId, row.docTitle, row.conUuid).then(res => {
            if (res.status == 200 && res.data.type == 'application/json') {
              const reader = new FileReader() //创建一个FileReader实例
              reader.readAsText(res.data, 'utf-8') //读取文件,结果用字符串形式表示
              reader.onload = function() {
                const result = JSON.parse(reader.result)
                window.open(result.data)
              }
            } else {
              this.$message({
                type: 'warning',
                message: '下载异常'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消下载'
          })
        })
    },
    contfiling(row) {
      console.info(row.contractId)
      this.$confirm('系统会自动归档合同,正常情况下无需手动归档, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          //调用归档api
          contFilingApi(row.contractId, row.conUuid).then(res => {
            res = res.data
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '归档成功'
              })
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    backToLoms(row) {
      this.$confirm('系统会定期自动回传合同至运营,正常情况下无需手动归档, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          //调用回传api
          this.config.loading = true
          contToLomsApi(row).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '回传成功'
              })
            } else {
              this.$message({
                type: 'warning',
                message: res.data.msg
              })
            }
            this.config.loading = false
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    }
  },
  created() {
    this.currentUser = window.localStorage.getItem('mobile')
    this.getList()
  }
}
</script>

<style lang="scss" scoped></style>
